// extracted by mini-css-extract-plugin
export default {"container":"file-name__container___Av4EM","measure":"file-name__measure___Yd5i4","fileName":"file-name__fileName___tbWVL","fileExtension":"file-name__fileExtension___II5j4"};